module.exports = __webpack_public_path__ + "static/media/illustration-home.b2c10a67.png";